import {isValidElement} from 'react'

import PropTypes from 'prop-types'

import {Icon as UIIcon, ICON_SIZES} from '@adv-mt/ui/icon'
import {Body1, Caption} from '@adv-mt/ui/typography'

import {BASE_CLASS} from './config.js'

const getIconContent = icon => {
  if (!icon) return null
  if (isValidElement(icon)) return icon
  const SvgIcon = icon
  return (
    <UIIcon size={ICON_SIZES.MD}>
      <SvgIcon size={ICON_SIZES.MD} />
    </UIIcon>
  )
}

const CharacteristicItem = ({icon, label, value}) => {
  if (!value) return null

  const iconContent = getIconContent(icon)

  return (
    <li className={`${BASE_CLASS}-item`}>
      {iconContent && <span className={`${BASE_CLASS}-itemIcon`}>{iconContent}</span>}
      <div className={`${BASE_CLASS}-itemContent`}>
        <Caption as="span" className={`${BASE_CLASS}-itemLabel`}>
          {label}
        </Caption>
        <Body1 highlight as="span" className={`${BASE_CLASS}-itemValue`}>
          {value}
        </Body1>
      </div>
    </li>
  )
}

CharacteristicItem.displayName = 'CharacteristicItem'
CharacteristicItem.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.elementType, PropTypes.element]),
  label: PropTypes.string,
  value: PropTypes.node
}

export default CharacteristicItem
